import { supabase } from '../lib/supabase';
export class UserService {
    /**
     * Get all users with pagination, search, and role filters (admin only)
     */
    static async getAllUsers(search, roleFilters, limit = 50, offset = 0) {
        const { data, error } = await supabase.rpc('get_all_users', {
            p_search: search || null,
            p_role_filters: roleFilters || null,
            p_limit: limit,
            p_offset: offset
        });
        if (error) {
            console.error('Error fetching users:', error);
            throw new Error(error.message);
        }
        if (!data || data.length === 0) {
            return { users: [], totalCount: 0 };
        }
        // Extract total count from first row
        const totalCount = data[0]?.total_count || 0;
        // Map to UserProfile objects
        const users = data.map((row) => ({
            id: row.id,
            email: row.email,
            first_name: row.first_name,
            last_name: row.last_name,
            roles: row.roles,
            created_at: row.created_at,
            updated_at: row.updated_at,
            email_confirmed_at: row.email_confirmed_at,
            last_sign_in_at: row.last_sign_in_at,
            assignments: row.assignments || [],
            studies: row.studies || []
        }));
        return { users, totalCount };
    }
    /**
     * Update user roles (admin only)
     */
    static async updateUserRoles(userId, roles) {
        const { error } = await supabase.rpc('update_user_roles', {
            p_user_id: userId,
            p_roles: roles
        });
        if (error) {
            console.error('Error updating user roles:', error);
            throw new Error(error.message);
        }
    }
    /**
     * Resend verification email to a user (admin only)
     * Uses an Edge Function to securely look up the email server-side
     */
    static async resendVerificationEmail(userId) {
        const { data, error } = await supabase.functions.invoke('resend-verification', {
            body: { user_id: userId }
        });
        if (error) {
            console.error('Error resending verification email:', error);
            throw new Error(error.message);
        }
        if (data?.error) {
            throw new Error(data.error);
        }
    }
}
